import React from 'react';

const AccessibilityHiddenImg = ({ ...params }) => {

    return (
        <img {...params} alt="" />
    );
};

export default AccessibilityHiddenImg;
